import { Outlet } from "react-router";
import FooterSection from "./footer-section";
import { getLocalData } from "~/data/lib/serverStore.server";
import { links as breadCrumbLinks } from "~/layout/public/bread-crumbs/bread-crumb-section";
import { links as contactLinks } from "~/components/pages/contact/contact-form";


export async function loader() {
  const data = await getLocalData();
  return data;
}

export default function SiteLayout() {
    return (
        <main id="main">
            <Outlet />
            <FooterSection />
        </main>
    );
}

export function links() {
  return [...breadCrumbLinks(), ...contactLinks()];
}